import { render, staticRenderFns } from "./RawReleaseDialog.vue?vue&type=template&id=39bf0ac1&scoped=true"
import script from "./RawReleaseDialog.vue?vue&type=script&lang=js"
export * from "./RawReleaseDialog.vue?vue&type=script&lang=js"
import style0 from "./RawReleaseDialog.vue?vue&type=style&index=0&id=39bf0ac1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf0ac1",
  null
  
)

export default component.exports